import React from 'react'


const ingredientContent = {
    title: "What’s so Special about Diddy Oil?",
    subtitle: "Pure Ingredients, Pure Love",
    description: [
      "Made with pure mineral oil and free from harsh chemicals, this Diddy Body Oil is formulated with high-quality ingredients designed to make a silky-smooth layer that protects and hydrates, leaving skin irresistibly soft.",
      "Whether it’s a night out, a date, or just some self-care, Diddy Oil is versatile and suited for every skin type. Look good, feel great, and stay moisturized.",
      "Life’s too short to be serious all the time. Diddy Oil adds a playful touch to your routine with a wink and a smile – because taking care of your skin should be fun, too."
    ],
    imageSrc: "images/Ingredients.png",
    altText: "Ingredients"
  };

const Ingredient = () => {
  return (
    <section className="ingredients">
      <div className="container-xl">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12">
            <img loading="lazy" decoding="async" width="546" height="430" className="img-fluid" src={ingredientContent.imageSrc} alt={ingredientContent.altText} />
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12">
            <div className="content-area">
              <h4>{ingredientContent.title}</h4>
              <h2>{ingredientContent.subtitle}</h2>
              {ingredientContent.description.map((para, index) => (
                <p key={index}>{para}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Ingredient